




















import Api from "./Api";
import {Component, Inject, Prop} from "vue-property-decorator";
import {DateTime, TerminalLocation} from "../../modules/models";
import CompanyUserRequired from "../CompanyRequired";

@Component
export default class AddTerminalDialog extends CompanyUserRequired {
    @Inject()
    api!: Api;

    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    description: string = "";
    deviceid: string = "";
    locid: number | null = null;
    loading = false;
    allLocations: TerminalLocation[] = [];

    get chooseLocs() {
        const threedaysAgo = DateTime.now().prevDay().prevDay().prevDay();
        return this.allLocations.filter((l) => l.shutdownTime === null || l.shutdownTime.isAfter(threedaysAgo));
    }

    validateDescription() {
        if(this.description.trim().length < 2) {
            return "Beskrivelse må være minst 2 bokstaver";
        }
        if(this.description.trim().length > 150) {
            return "Beskrivelse må være kortere enn 150 bokstaver";
        }
        return true;
    }
    validateDeviceid() {
        // When IMEI is not available device will generate random deviceid string of format R#<random string>, where
        // <random string> is a string og length 6 with random lowercase letters in range a-z or digits in range 0-9
        if(this.deviceid.length < 2) {
            return "IMEI er påkrevd";
        }
        const isRandomId = this.deviceid.startsWith("R#");
        if(isRandomId) {
            if(this.deviceid.match(/R#[0-9a-z]{6}/) === null) {
                return "Delen etter R# må bestå av 6 små bokstaver eller tall"
            }
        } else {
            if (this.deviceid.match(/[^0-9]/) !== null) {
                return "IMEI må være et tall"
            }
            if (this.deviceid.trim().length < 14) {
                return "IMEI må være minst 14 siffer";
            }
            if (this.deviceid.trim().length > 15) {
                return "IMEI må være maks 15 siffer";
            }
        }
        return true;
    }
    get notReadyToCreate() {
        return this.validateDeviceid() !== true || this.validateDescription() !== true;
    }

    async  createPendingconfig() {
        this.loading = true;
        try {
            let locid = this.locid;
            if(locid === 0) {
                locid = null;
            }
            const msg = await this.api.newTerminalSetup(this.company.orgNum, this.deviceid, this.description, locid);
            this.opened = false;
            if(msg != null) {
                throw new Error(msg.msg);
            }
            this.$emit("add-terminal", this.description);
        } catch(err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    loadingLocations = false;
    async load() {
        this.loadingLocations = true;
        try {
            const locsWithStats = await this.api.fetchLocations(this.company.orgNum);
            const nullLoc = new TerminalLocation(
                0, "Uten anlegg", 0, false, null, null,
                null, null, false, false,
                false, false, 0, false, true
            );
            this.allLocations = [nullLoc].concat(locsWithStats.map((lws) => lws.termloc));
        } catch(err) {
            this.emitError(err);
        } finally {
            this.loadingLocations = false;
        }
    }

    // hook
    created() {
        this.load();
    }
}
